import { ReactNode } from 'react';

interface SectionContainerProps {
  className?: string;
  children: ReactNode;
}

const SectionContainer = ({ className = '', children }: SectionContainerProps) => {
  return (
    <section
      className={`container mx-auto ${className}`}>
      {children}
    </section>
  )
}

export default SectionContainer
